import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { LanguageContext } from '../contexts/LanguageProvider';

const texts = {
  pt: {
    title: 'Atenção',
    body: 'O conteúdo deste site é destinado a agricultores da cafeicultura e demais setores agrícolas.',
    ok: 'OK',
  },
  en: {
    title: 'Notice',
    body: 'The content of this site is intended for coffee farmers and other agricultural sectors.',
    ok: 'OK',
  },
};

const STORAGE_KEY = 'siteDisclaimerSeen';

export default function SiteDisclaimerModal() {
  const { language } = useContext(LanguageContext);
  const t = texts[language] || texts.pt;
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
    } catch (e) { /* ignora */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignora */ }
    setShow(false);
  };

  return (
    <Modal show={show} onHide={accept} centered backdrop="static" contentClassName="disclaimer-modal">
      <Modal.Body className="p-4">
        <p className="mb-3">
          <strong>{t.title}:</strong> {t.body}
        </p>
        <Button variant="brand" onClick={accept}>{t.ok}</Button>
      </Modal.Body>
    </Modal>
  );
}
